import app from '@frontend/application-container';
import { SettingsEntry } from '../settings-entry';
import { Length } from '@frontend/Units';
import FormSelect, { Entry } from '@frontend/components/FormSelect';
import { img } from '@phi/components';
import { h } from 'vue';
import icon from '../../../../../frontend/phi3d/src/assets/img/SVG_icons/Bottom/visualisation/set_model_units.svg';

export const ModelUnitsIcon = icon;

const FormSelectLength = FormSelect<Length>();

const options: Array<Entry<Length>> = [
    { value: Length.cm, text: 'Centimeter' },
    { value: Length.ft, text: 'Foot' },
    { value: Length.in, text: 'Inch' },
    { value: Length.m, text: 'Meter' },
    { value: Length.mm, text: 'Millimeter' },
    { value: Length.yd, text: 'Yard' },
];

export function LengthUnit() {
    return SettingsEntry(
        'Workspace units',

        'Set the length units for your workspace. You can configure the default units through Onshape.',

        img(icon, 'Workspace units'),

        h(FormSelectLength, {
            options,
            value: app.state.display_units,
            'onUpdate:value': x => app.state.display_units = x,
        }),
    );
}
